module.exports = __webpack_public_path__ + "static/media/awe_logo_sm.e9cec486.png";